<template>
  <v-select
    :value="value"
    :items="items"
    :item-value="itemValue"
    :item-text="itemText"
    :hint="hint"
    persistent-hint
    dense
    @input="$emit('input', $event)"
  >
    <template v-slot:label>
      <field-help-label :label="label" :field="field" />
    </template>
  </v-select>
</template>

<script>
import FieldHelpLabel from '@/components/FieldHelpLabel/FieldHelpLabel.vue';

export default {
  name: 'BooleanOverrideSelect',
  components: { FieldHelpLabel },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    itemValue(item) {
      return item.value;
    },
    itemText(item) {
      return item.name;
    },
  },
};
</script>
